import { Language } from '../../../pure-js/types/Antiloop.js'
import { getLanguageCode } from '../hooks/useDefaultLanguage.js'
import {
  getGrooverText as getGrooverTextCore,
  getGrooverTextStyle as getGrooverTextStyleCore,
  hasGrooverText as hasGrooverTextCore,
  formatGrooverText as formatGrooverTextCore,
  makeBold as makeBoldCore
} from '../../../pure-js/libs/GrooverTextRepository.js'

export type { Printable, Options } from '../../../pure-js/libs/GrooverTextRepository.js'

/**
 * Get text from the new compact text system (user-web wrapper)
 */
export const getGrooverText = (
  textKey: string | any,
  language: Language = getLanguageCode(),
  customerId?: string
): string => {
  return getGrooverTextCore(textKey, language, customerId)
}

/**
 * Get text style from the new compact text system (user-web wrapper)
 */
export function getGrooverTextStyle(styleKey: string): React.CSSProperties {
  return getGrooverTextStyleCore(styleKey) as React.CSSProperties
}

/**
 * Check if a text key exists in the new compact format (user-web wrapper)
 */
export const hasGrooverText = (key: string): boolean => {
  return hasGrooverTextCore(key)
}

/**
 * Format text with parameters (user-web wrapper)
 */
export const formatGrooverText = formatGrooverTextCore

/**
 * Make text bold (user-web wrapper)
 */
export const makeBold = makeBoldCore
